import React from 'react';

export default function useScheduleSave({
  dispatch,
  onClose,
  isFetchingSchedules,
  scopeKey,
}) {
  const [pendingScope, setPendingScope] = React.useState(null);
  const currentScope = React.useRef(null);
  const mounted = React.useRef(false);
  if (!currentScope.current || currentScope.current.key !== scopeKey) {
    currentScope.current = {
      key: scopeKey,
      pendingRequests: 0,
    };
  }
  const scope = currentScope.current;

  React.useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const isCurrentScope = () => mounted.current && currentScope.current === scope;

  const saveSchedule = async (action) => {
    if (!isCurrentScope()) return undefined;
    scope.pendingRequests += 1;
    setPendingScope(scope);
    try {
      return await dispatch(action);
    } finally {
      scope.pendingRequests -= 1;
      if (isCurrentScope() && !scope.pendingRequests) setPendingScope(null);
    }
  };

  const closeSchedule = (...args) => {
    if (isCurrentScope() && !scope.pendingRequests && !isFetchingSchedules) onClose(...args);
  };

  return {
    isSaving: pendingScope === scope || isFetchingSchedules,
    hasPendingSave: pendingScope === scope,
    isCurrentScope,
    saveSchedule,
    closeSchedule,
  };
}
